import React from 'react';
import { HighSchoolTeamEventRegistrationsCardFragment } from '../../../generated/spin-graphql';
import { gql } from '@urql/core';
import { EventCard } from '../../events/card/EventCard';

type Props = {
    team: HighSchoolTeamEventRegistrationsCardFragment;
};

gql`
    fragment HighSchoolTeamEventRegistrationsCard on espin_team {
        display_name
        event_registrations(
            order_by: { event: { event_start_date: asc } }
            where: {
                team: { high_school_id: { _eq: $highSchoolId } }
                event: { event_end_date: { _gte: "now()" }, status: { _eq: published } }
            }
        ) {
            event {
                ...MyEventsCard
            }
        }
    }
`;

export const HighSchoolTeamEventRegistrationsCard: React.FC<Props> = ({ team }) => {
    return (
        <div className="my-events-card">
            <h2 className="team-name">{team.display_name}</h2>
            <div className="events-list">
                {team.event_registrations.map((event_registration, index: number) => (
                    <EventCard
                        key={`event-registration-${index}`}
                        event={event_registration.event}
                        isRegistered={true}
                    />
                ))}
            </div>
        </div>
    );
};
